module.exports = __webpack_public_path__ + "media/icons/hole-a984bff7.png";